module.exports = "./img/2bbd161f8bb9b61f2b4a7bbef66cb2f9.jpg";